import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-select-equipment-pu',
  templateUrl: './select-equipment-pu.component.html',
  styleUrls: ['./select-equipment-pu.component.css']
})
export class SelectEquipmentPuComponent implements OnInit {
    webPageName;

    operationId;

    public itemsListEquipmentPus: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.webPageName = this.stateService.getStateParams()['webpagename'];
        this.operationId = this.stateService.getStateParams()['operation_id'];
    }

    private async loadEquipmentPus() {
        if (!!this.webPageName && !!this.operationId) {
            this.itemsListEquipmentPus = await this.datatask.Post(201, {
                webpagename: this.webPageName,
                operation_id: this.operationId
            });
        }
    }

    public async goBackToPrevious(event: { item: Item; event: MouseEvent }) {
        await this.datatask.Post(202, {
            equipment_id: event.item?.item_id,
            webpagename: this.webPageName
        });

        this.stateService.back();
    }

    private async init() {
        this.loadEquipmentPus();
    }

    ngOnInit() {
        this.init();
    }
}
